import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import BiographySection from './components/BiographySection';
import PhilosophySection from './components/PhilosophySection';
import CallToActionSection from './components/CallToActionSection';

export default function About() {
  useEffect(() => {
    // Set page-specific meta tags
    document.title = 'About Tony Monteiro | Licensed Mortgage Agent';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Meet Tony Monteiro, Level 2 licensed mortgage agent (Lic#13121) providing personalized home financing and refinancing solutions across Waterloo, Brant, and Wellington.');
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'Tony Monteiro Level 2 Mortgage Agent, licensed mortgage broker Ontario, expert mortgage advisor Waterloo Brant Wellington, professional home financing GGH Ontario mortgage expert');
    
    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://mortgagesforyoubytony.ca/about');

    // Add JSON-LD schema
    const existingSchema = document.querySelector('script[type="application/ld+json"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = '{"@context":"https://schema.org","@graph":[{"@type":"Person","@id":"https://mortgagesforyoubytony.ca/#tony","name":"Tony Monteiro","jobTitle":"Mortgage Agent Level 2","identifier":"Lic# 13121","worksFor":{"@type":"Organization","@id":"https://mortgagesforyoubytony.ca/#org","name":"Tony Monteiro Mortgages","url":"https://mortgagesforyoubytony.ca/"},"telephone":"+1-519-658-3026","email":"tjcmonteiro@rogers.com","areaServed":["Waterloo","Brant County","Wellington County","Greater Golden Horseshoe"]},{"@type":"AboutPage","url":"https://mortgagesforyoubytony.ca/about","name":"About Tony Monteiro"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://mortgagesforyoubytony.ca/"},{"@type":"ListItem","position":2,"name":"About","item":"https://mortgagesforyoubytony.ca/about"}]}]}';
    document.head.appendChild(schemaScript);
  }, []);

  return (
    <div className="min-h-screen bg-dark-900">
      <Header />
      <main>
        <BiographySection />
        <PhilosophySection />
        <CallToActionSection />
      </main>
      <Footer />
    </div>
  );
}